










import { Component, Vue, Watch } from 'vue-property-decorator';
import { settingsModule } from '@/store/modules/ModuleSettings';

/** document hooks */
const {
	version
}: // eslint-disable-next-line @typescript-eslint/no-var-requires
any = require('element-ui/package.json');

/** document hooks */
const ORIGINAL_THEME: any = '#409EFF';

@Component({
	name: 'ThemePicker'
})
/** ThemePicker */
export default class ThemePicker extends Vue {
	/** document hooks */
	private chalk: any = '';

	/** document hooks */
	private theme: any = '';

	/** document hooks */
	private get defaultTheme(): any {
		return settingsModule.theme;
	}

	/** document hooks */
	@Watch('defaultTheme', {
		immediate: true
	})
	private onDefaultThemeChange(value: string): any {
		this.theme = value;
	}

	/** document hooks */
	@Watch('theme')
	private async onThemeChange(value: string): Promise<any> {
		if (!value) {
			return null;
		}

		const oldValue: any = this.chalk ? this.theme : ORIGINAL_THEME;
		const themeCluster: any = this.getThemeCluster(value.replace('#', ''));
		const originalCluster: any = this.getThemeCluster(oldValue.replace('#', ''));
		const message: any = this.$message({
			message: '  Compiling the theme',
			customClass: 'theme-message',
			type: 'success',
			duration: 0,
			iconClass: 'el-icon-loading'
		});

		if (!this.chalk) {
			const url: any = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`;

			await this.getCSSString(url, 'chalk');
		}

		// eslint-disable-next-line require-jsdoc
		const getHandler: any = (variable: string, id: string): any => (): any => {
			// eslint-disable-next-line no-shadow
			const originalCluster: any = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''));
			// eslint-disable-next-line @typescript-eslint/no-this-alias
			const thisVal: any = this;
			const newStyle: any = this.updateStyle(thisVal[variable], originalCluster, themeCluster);

			let styleTag: any = document.getElementById(id);

			if (!styleTag) {
				styleTag = document.createElement('style');
				styleTag.setAttribute('id', id);
				document.head.appendChild(styleTag);
			}

			styleTag.innerText = newStyle;
		};

		const chalkHandler: any = getHandler('chalk', 'chalk-style');

		chalkHandler();

		// eslint-disable-next-line prefer-reflect
		let styles: HTMLElement[] = [].slice.call(document.querySelectorAll('style'));

		styles = styles.filter((style: any): any => {
			const text: any = style.innerText;

			// eslint-disable-next-line wrap-regex
			return new RegExp(oldValue, 'i').test(text) && !/Chalk Variables/.test(text);
		});
		styles.forEach((style: any): any => {
			const { innerText }: any = style;

			if (typeof innerText !== 'string') {
				return;
			}

			// eslint-disable-next-line no-param-reassign
			style.innerText = this.updateStyle(innerText, originalCluster, themeCluster);
		});

		this.$emit('change', value);
		message.close();
	}

	/** document hooks */
	private updateStyle(style: string, oldCluster: string[], newCluster: string[]): any {
		let newStyle: any = style;

		oldCluster.forEach((color: any, index: any) => {
			newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index]);
		});

		return newStyle;
	}

	/** document hooks */
	private getCSSString(url: string, variable: string): any {
		return new Promise((resolve: any): any => {
			const xhr: any = new XMLHttpRequest();

			xhr.onreadystatechange = (): any => {
				if (xhr.readyState === 4 && xhr.status === 200) {
					// eslint-disable-next-line @typescript-eslint/no-this-alias
					const thisVal: any = this;

					thisVal[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '');
					resolve();
				}
			};

			xhr.open('GET', url);
			xhr.send();
		});
	}

	/** document hooks */
	private getThemeCluster(theme: string): any {
		// eslint-disable-next-line require-jsdoc
		const tintColor: any = (color: string, tint: number): any => {
			let red: any = parseInt(color.slice(0, 2), 16);
			let green: any = parseInt(color.slice(2, 4), 16);
			let blue: any = parseInt(color.slice(4, 6), 16);

			if (tint === 0) {
				// when primary color is in its rgb space
				return [red, green, blue].join(',');
			}

			red += Math.round(tint * (255 - red));
			green += Math.round(tint * (255 - green));
			blue += Math.round(tint * (255 - blue));

			return `#${red.toString(16)}${green.toString(16)}${blue.toString(16)}`;
		};

		// eslint-disable-next-line require-jsdoc
		const shadeColor: any = (color: string, shade: number): any => {
			let red: any = parseInt(color.slice(0, 2), 16);
			let green: any = parseInt(color.slice(2, 4), 16);
			let blue: any = parseInt(color.slice(4, 6), 16);

			red = Math.round((1 - shade) * red);
			green = Math.round((1 - shade) * green);
			blue = Math.round((1 - shade) * blue);

			return `#${red.toString(16)}${green.toString(16)}${blue.toString(16)}`;
		};

		const clusters: any = [theme];

		for (let i: any = 0; i <= 9; i++) {
			clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
		}

		clusters.push(shadeColor(theme, 0.1));

		return clusters;
	}
}
